(() => {
  const FACET_BUTTON_SELECTOR = '#facet-button';
  const FACET_CLOSE_SELECTOR = '[data-facet-menu-close]';
  const DESKTOP_MENU_ID = 'toggle-facet-menu';
  const MOBILE_MENU_ID = 'toggle-facet-menu-mobile';
  const MOBILE_BODY_CLASS = 'collection-mobile-filter-open';
  let mobileCloseCount = 0;

  const isMobileViewport = () => {
    if (window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.medium) {
      return window.PXUTheme.media_queries.medium.matches;
    }

    return window.matchMedia('(max-width: 798px)').matches;
  };

  const canBeShownByLayout = (menu) => {
    if (!menu) return false;

    const wasHidden = menu.classList.contains('hidden');
    if (wasHidden) menu.classList.remove('hidden');
    const canShow = window.getComputedStyle(menu).display !== 'none';
    if (wasHidden) menu.classList.add('hidden');

    return canShow;
  };

  const resolveTargetMenu = () => {
    const desktopMenu = document.getElementById(DESKTOP_MENU_ID);
    const mobileMenu = document.getElementById(MOBILE_MENU_ID);

    const desktopAvailable = canBeShownByLayout(desktopMenu);
    const mobileAvailable = canBeShownByLayout(mobileMenu);

    if (desktopAvailable && !mobileAvailable) return { target: desktopMenu, alternate: mobileMenu };
    if (mobileAvailable && !desktopAvailable) return { target: mobileMenu, alternate: desktopMenu };

    const target = isMobileViewport() ? mobileMenu : desktopMenu;
    const alternate = target === mobileMenu ? desktopMenu : mobileMenu;
    return { target, alternate };
  };

  const setFacetState = (isOpen, target) => {
    const facetButton = document.querySelector(FACET_BUTTON_SELECTOR);
    if (facetButton) {
      facetButton.setAttribute('aria-expanded', String(isOpen));
    }

    document.body.classList.toggle(MOBILE_BODY_CLASS, isOpen && target?.id === MOBILE_MENU_ID);
  };

  const getOpenMobileMenu = () => {
    const mobileMenu = document.getElementById(MOBILE_MENU_ID);
    return mobileMenu && !mobileMenu.classList.contains('hidden') ? mobileMenu : null;
  };

  const getFocusableElements = (container) =>
    Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0);

  const closeFacetMenu = () => {
    const desktopMenu = document.getElementById(DESKTOP_MENU_ID);
    const mobileMenu = document.getElementById(MOBILE_MENU_ID);
    const hadOpenMobileMenu = mobileMenu && !mobileMenu.classList.contains('hidden');

    if (desktopMenu) desktopMenu.classList.add('hidden');
    if (mobileMenu) mobileMenu.classList.add('hidden');

    if (hadOpenMobileMenu) {
      mobileCloseCount += 1;
    }

    setFacetState(false, mobileMenu);

    const facetButton = document.querySelector(FACET_BUTTON_SELECTOR);
    if (facetButton) {
      facetButton.focus({ preventScroll: true });
    }
  };

  const openMobileFacetMenu = ({ focus = true } = {}) => {
    const desktopMenu = document.getElementById(DESKTOP_MENU_ID);
    const mobileMenu = document.getElementById(MOBILE_MENU_ID);
    if (!mobileMenu) return;

    mobileMenu.classList.remove('hidden');
    if (desktopMenu) {
      desktopMenu.classList.add('hidden');
    }

    setFacetState(true, mobileMenu);

    if (!focus) return;

    const closeButton = mobileMenu.querySelector(FACET_CLOSE_SELECTOR);
    if (closeButton) {
      closeButton.focus({ preventScroll: true });
    }
  };

  const toggleFacetMenu = () => {
    const { target, alternate } = resolveTargetMenu();
    if (!target) return;

    const isHidden = target.classList.toggle('hidden');
    if (alternate) {
      alternate.classList.add('hidden');
    }

    setFacetState(!isHidden, target);

    if (!isHidden && target.id === MOBILE_MENU_ID) {
      openMobileFacetMenu();
    }
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest(FACET_CLOSE_SELECTOR);
    if (closeButton) {
      event.preventDefault();
      closeFacetMenu();
      return;
    }

    const mobileMenu = document.getElementById(MOBILE_MENU_ID);
    if (mobileMenu && event.target === mobileMenu) {
      event.preventDefault();
      closeFacetMenu();
      return;
    }

    const facetButton = event.target.closest(FACET_BUTTON_SELECTOR);
    if (!facetButton) return;

    event.preventDefault();
    toggleFacetMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeFacetMenu();
      return;
    }

    if (event.key !== 'Tab') return;

    const mobileMenu = getOpenMobileMenu();
    if (!mobileMenu) return;

    const focusableElements = getFocusableElements(mobileMenu);
    if (focusableElements.length === 0) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus({ preventScroll: true });
    }
  });

  window.PawuniCollectionFacetMenu = {
    close: closeFacetMenu,
    getMobileCloseCount: () => mobileCloseCount,
    openMobile: openMobileFacetMenu,
  };
})();
